export default function * failure ({ error }) {
  if(error?.response?.status===503){
    alert('We are currently experiencing technical difficulties with our mobile app which may impact the ability to schedule an appointment.\r\nEvery part of your donation experience matters to us, and we apologize for any inconvenience.\r\nIf you have questions about an upcoming scheduled appointment, please call your donation center during standard business hours.')
  }
}